import React, { Fragment, useState } from 'react';
import icArrow1 from 'Assets/img/sidebar/ic_arrow_222_20.png';
import icArrow2 from 'Assets/img/sidebar/ic_arrow_222_20@2x.png';
import icArrow3 from 'Assets/img/sidebar/ic_arrow_222_20@3x.png';
import { getImageSet } from 'Util/DataUtils';
import IntlMessages from 'Util/IntlMessages';
import YearDropdown from './YearDropdown';
import SearchInput from './SearchInput';
import { useDispatch, useSelector } from 'react-redux';
import useFilter from '../hooks/useFilter';
import { useIntl } from 'react-intl';
import SelectFieldItem from './SelectFieldItem';
import { usePopup } from 'Util/usePopup';
import { setLoading } from 'Actions/LoadingActions';
import { patchFieldActive } from 'Api/endpoints/User';
import { useError } from 'Api/hooks/useError';
import { setAllFieldList, setDefaultField } from 'Actions/ConfigActions';
import { getFieldAllList } from 'Api/endpoints/User';
import toast from 'react-hot-toast';
import { isVietnam } from 'Util/DataUtils';

const icArrow = getImageSet([icArrow1, icArrow2, icArrow3]);

const EditSection = ({ goToBasic, goToStorage }) => {
  const { user } = useSelector(state => state.authUser);
  const { allFieldList, defaultField } = useSelector(state => state.config);
  const { searchText, updateText, getFilteredList, yearList, selectedYear, updateYear } = useFilter({ fieldList: allFieldList });
  const { formatMessage } = useIntl();
  const [selectedFieldList, setSelectedFieldList] = useState([]);
  const { showDialog } = usePopup();
  const dispatch = useDispatch();
  const { showErrorPopup } = useError();

  const toggleSelectedField = fieldId => {
    if (selectedFieldList.includes(fieldId)) {
      setSelectedFieldList(prev => prev.filter(id => id !== fieldId));
    } else {
      setSelectedFieldList(prev => [...prev, fieldId]);
    }
  };

  const renderCustomToast = () => {
    const text = formatMessage({ id: 'sidebar.field.edit.storage.success' }, { count: selectedFieldList.length });
    const highlightText = formatMessage({ id: 'sidebar.field.edit.storage' });
    return (
      <div className="sidebar-field-edit-toast-message">
        {text.split(highlightText).map((part, index, array) => {
          if (index === array.length - 1) {
            return <span key={index}>{part}</span>;
          }
          return (
            <Fragment key={index}>
              <span>{part}</span>
              <span className="highlight">{highlightText}</span>
            </Fragment>
          );
        })}
      </div>
    );
  };

  const hideField = async () => {
    try {
      dispatch(setLoading(true));
      const result = await patchFieldActive({
        active: false,
        fieldIds: selectedFieldList,
      });
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      let remainingFieldList = allFieldList.filter(field => !selectedFieldList.includes(field._id));
      if (remainingFieldList.length === 0) {
        try {
          const response = await getFieldAllList({ page: 1 });
          if (response.err) {
            showErrorPopup({ text: response.err.response.data.message });
            return;
          }
          if (response.data) {
            remainingFieldList = response.data.items;
          }
        } catch (e) {
          console.log(e);
        }
      }
      dispatch(setAllFieldList(remainingFieldList));
      if (selectedFieldList.includes(defaultField._id)) {
        dispatch(setDefaultField(remainingFieldList[0]));
      }
      toast.custom(renderCustomToast);
      setSelectedFieldList([]);
      goToBasic();
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleHideField = () => {
    showDialog({
      title: 'sidebar.field.edit.storage.title',
      content: 'sidebar.field.edit.storage.sub',
      onConfirm: hideField,
      confirmText: 'sidebar.field.edit.storage.button',
      cancelText: 'common.no',
      confirmTextColor: '#FF4B4B',
    });
  };

  return (
    <>
      <div className="field-sidebar-fixed" data-field-toggle="true" style={{ gap: '20px' }}>
        <div className="field-sidebar-header">
          <div className="field-sidebar-header-edit-left cursor-pointer" onClick={goToBasic}>
            <img {...icArrow} alt="arrow" />
            <div className={`field-sidebar-header-edit-left-title ${isVietnam(user) && 'vi'}`}>
              <IntlMessages id="sidebar.field.edit.title" />
            </div>
          </div>
          <div className="field-sidebar-header-edit-right">
            {selectedFieldList.length > 0 ? (
              <span className="cursor-pointer no-drag" style={{ color: '#0567F9' }} onClick={handleHideField}>
                <IntlMessages id="sidebar.field.edit.hide" />
              </span>
            ) : (
              <span className="cursor-pointer no-drag" onClick={goToStorage}>
                <IntlMessages id="sidebar.field.edit.storage" />
              </span>
            )}
          </div>
        </div>
        <div className="field-sidebar-filter-container">
          {yearList.length > 1 && <YearDropdown options={yearList} value={selectedYear} onChange={updateYear} />}
          <SearchInput text={searchText} onChangeText={e => updateText(e.target.value)} />
        </div>
      </div>
      <div className="field-sidebar-list">
        {searchText && getFilteredList.length === 0 ? (
          <div className="field-sidebar-list-empty">
            '<span className="field-sidebar-list-empty-highlight">{searchText}</span>'{formatMessage({ id: 'sidebar.field.empty.list' })}
          </div>
        ) : (
          getFilteredList.map(field => {
            const isSelected = selectedFieldList.includes(field._id);
            return <SelectFieldItem key={field._id} field={field} isSelected={isSelected} onSelect={() => toggleSelectedField(field._id)} searchText={searchText} />;
          })
        )}
      </div>
    </>
  );
};

export default EditSection;
